import { showPipelineErrorToast } from "../components/clinicalEval/PipelineToasts";

export const normalizePmids = (pmids) =>
  Array.from(new Set((pmids || []).filter(Boolean).map(String)));

export const extractPmid = (item) => {
  if (!item || typeof item !== "object") return null;
  return (
    item.pmid ??
    item.PMID ??
    item.pubmed_id ??
    item.pubmedId ??
    item.pubmedID ??
    null
  );
};

export const diffPmids = (previousPmids, currentPmids) => {
  const previous = new Set(normalizePmids(previousPmids));
  const current = new Set(normalizePmids(currentPmids));
  return [...previous].filter((pmid) => !current.has(pmid));
};

export const checkPipelineLoss = ({
  previousStage,
  currentStage,
  previousPmids,
  currentPmids,
}) => {
  if (!Array.isArray(previousPmids) || previousPmids.length === 0) return;
  if (!Array.isArray(currentPmids)) return;

  const missing = diffPmids(previousPmids, currentPmids);
  if (missing.length === 0) return;

  const message = `${missing.length} items lost in data processing between ${previousStage} -> ${currentStage}. Missing PMIDs: [${missing.join(", ")}]`;
  showPipelineErrorToast(message);
};
